import axios from 'axios';

// export const publicUrl = '/api'; //本地
export const publicUrl = 'https://www.fcsleep.com/api/SleepNew/public/index.php/vueapi'; //线上 new

export const Login = `${publicUrl}/Login/Login`; // 登录 
export const RegisterUser = `${publicUrl}/Login/RegisterUser`; // 注册账号
export const ForgotPassword = `${publicUrl}/Login/ForgotPassword`; // 找回密码
export const SendSmsCode = `${publicUrl}/Login/SendSmsCode`; // 发送验证码
export const LoginOut = `${publicUrl}/Login/LoginOut`; // 退出登录
export const IsLogin = `${publicUrl}/Login/IsLogin`; // 是否登录

export const NewsList = `${publicUrl}/Index/NewsList`; // 首页-健康咨询列表
export const NewsInfo = `${publicUrl}/Index/NewsInfo`; // 首页-健康咨询详情
export const SpecialityServerInfo = `${publicUrl}/About/SpecialityServerInfo`; // 专业服务
export const FeeStandardInfo = `${publicUrl}/About/FeeStandardInfo`; // 收费标准
export const AboutInfo = `${publicUrl}/About/AboutInfo`; // 关于我们
export const HealthySchemeList = `${publicUrl}/Healthy/HealthySchemeList`; // 健康方案列表
export const HealthyList = `${publicUrl}/Healthy/HealthyList`; // 获取健康方案题目列表
export const QuestionNewInfo = `${publicUrl}/Healthy/QuestionNewInfo`; // 健康方案新闻详情
export const GetHealthyScore = `${publicUrl}/Healthy/GetHealthyScore`; // 提交获取分数及描述
export const UserInfo = `${publicUrl}/User/UserInfo`; // 账户信息
export const EditUserInfo = `${publicUrl}/User/EditUserInfo`; // 修改账户信息
export const TestQuestionList = `${publicUrl}/User/TestQuestionList`; // 我的测试列表
export const TestQuestionInfo = `${publicUrl}/User/TestQuestionInfo`; // 我的测试详情
export const DelTestQuestion = `${publicUrl}/User/DelTestQuestion`; // 删除测试记录
export const PayTags = `${publicUrl}/user/PayTags`; // 充值金额
export const Wxpay = `${publicUrl}/Wxpay/Wxpay`; // 获取支付订单号
export const GetOrderStatus = `${publicUrl}/WxPay/GetOrderStatus`; // 获取微信支付的状态
// 19.08.22
export const QuestionItemInfo = `${publicUrl}/Healthy/QuestionItemInfo`; // 健康方案商品详情  传 id  健康方案的id
export const ItemWxPay = `${publicUrl}/Wxpay/ItemWxPay`; //   健康小工具商品的提交信息   传 id 支付的商品id
// 20.03.04
export const CarList = `${publicUrl}/Wxpay/CarList`; // 购物车列表
export const AddCar = `${publicUrl}/Wxpay/AddCar`; // 加入购物车   id 商品ID
export const DelCarInfo = `${publicUrl}/Wxpay/DelCarInfo`; // 删除购物车商品   car_id 购物车ID
export const Settlement = `${publicUrl}/Wxpay/Settlement`; // 购物车结算   car_ids 购物车ID，逗号拼接  返回：price 金额，order_no 订单号，url 地址 ，title 标题

//商品列表
export const HealthySchemeItemList = `${publicUrl}/Healthy/HealthySchemeItemList`; // 商品列表